<div class="page-content">
    <p-panel header="Users management" class="no-x-padding">
        <p-message severity="warn" styleClass="mt-2 mb-2">
            <span>
                Users from SSO/LDAP/OAuth (external) don't need to be created manually, they will be created automaticly
                upon their first connection to the application
            </span>
        </p-message>
        <app-user-crud></app-user-crud>
    </p-panel>
</div>
